module.exports = __webpack_public_path__ + "static/media/Siam_Cement_Group_Logo.svg.242cbed7.png";